import { render } from "./TwoFaResetSuccess.vue?vue&type=template&id=2cca80a4&scoped=true"
import script from "./TwoFaResetSuccess.vue?vue&type=script&lang=js"
export * from "./TwoFaResetSuccess.vue?vue&type=script&lang=js"

import "./TwoFaResetSuccess.vue?vue&type=style&index=0&id=2cca80a4&scoped=true&lang=css"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cca80a4"],['__file',"src/views/TwoFaReset/TwoFaResetSuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cca80a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cca80a4', __exports__)) {
    console.log('reload')
    api.reload('2cca80a4', __exports__)
  }
  
  module.hot.accept("./TwoFaResetSuccess.vue?vue&type=template&id=2cca80a4&scoped=true", () => {
    console.log('re-render')
    api.rerender('2cca80a4', render)
  })

}


export default __exports__